import router from './index'
export default [
  {
    path: '/main/project/:projectId',
    name: 'Project',
    meta: {
      title: '首頁',
      firstChildren: true
    },
    component: () => import('@/views/Tablet'),
    redirect: to => {
      return { name: 'FunctionIndex' }
    },
    children: [
      {
        path: '/',
        name: 'FunctionIndex',
        meta: {
          title: '功能列表'
        },
        component: () => import('@/views/Tablet/FunctionsIndex'),
        redirect: to => {
          return { name: 'Functions' }
        },
        children: [
          {
            path: '/',
            name: 'Functions',
            meta: {
              title: '功能列表',
              firstChildren: true

            },
            component: () => import('@/views/Tablet/Functions')
          },
          {
            path: 'information',
            name: 'NormalInformation',
            meta: {
              title: '工程概要'
            },
            component: () => import('@/views/Tablet/NormalInformation')
          },

          {
            path: 'appointmentList',
            name: 'AppointmentList',
            meta: {
              title: '通報單列表'
            },
            component: () => import('@/components/resource/m_appointment/AppointmentSheetList'),
            beforeEnter: async (to, from, next) => {
              if ('parent' in router.app.$store.state.project.current) {
                await router.app.$store.dispatch('project/getProjectItemAndStore', router.app.$store.state.project.current.parent)
              } else {
                await router.app.$store.dispatch('project/getProjectItemAndStore', router.app.$store.state.project.current._id)
              }
              next()
            }
          },
          {
            path: 'sheet-information',
            name: 'AppointmentSheet',
            meta: {
              title: '工程概要'
            },
            component: () => import('@/components/resource/m_appointment/AppointmentSheet')
          },
          {
            path: 'inspection',
            name: 'InspectionsIndex',
            meta: {
              title: '自主檢查列表'
            },
            component: () => import('@/views/Tablet/InspectionsIndex'),
            redirect: to => {
              return { name: 'Inspections' }
            },
            children: [
              {
                path: 'list',
                name: 'Inspections',
                meta: {
                  title: '列表',
                  firstChildren: true
                },
                component: () => import('@/components/resource/m_inspection/Inspections')
              },
              {
                path: 'add',
                name: 'AddInspection',
                meta: {
                  title: '新增',
                  isAddInspection: true
                },
                component: () => import('@/views/Tablet/Inspection'),
                beforeEnter: async (to, from, next) => {
                  await router.app.$store.dispatch('inspection/setNewInspection', to.params.inspectionId)
                  next()
                }
              },
              {
                path: ':inspectionId',
                name: 'Inspection',
                meta: {
                  title: '自主檢查表',
                  isAddInspection: false
                },
                component: () => import('@/views/Tablet/Inspection'),
                beforeEnter: async (to, from, next) => {
                  await router.app.$store.dispatch('inspection/storeInspection', to.params.inspectionId)
                  next()
                }
              }
            ]
          },
          {
            path: 'errorRecord',
            name: 'ErrorRecordIndex',
            meta: {
              title: '缺失改善列表'
            },
            component: () => import('@/views/Tablet/ErrorRecordIndex'),
            redirect: to => {
              return { name: 'ErrorRecords' }
            },
            children: [
              {
                path: 'list',
                name: 'ErrorRecords',
                meta: {
                  title: '列表',
                  firstChildren: true
                },
                component: () => import('@/components/resource/m_errorRecord/ErrorRecords')
              },
              {
                path: 'add',
                name: 'AddErrorRecord',
                meta: {
                  title: '新增',
                  isAddErrorRecord: true
                },
                component: () => import('@/components/resource/m_errorRecord/AddErrorRecord')
              },
              {
                path: ':errorRecordId',
                name: 'ErrorRecord',
                meta: {
                  title: '缺失改善表',
                  isAddErrorRecord: false
                },
                component: () => import('@/components/resource/m_errorRecord/ErrorRecord')
              }
            ]
          },
          {
            path: 'file-management',
            name: 'FileManagement',
            meta: {
              title: '檔案管理'
            },
            component: () => import('@/components/resource/m_file/FileManagement')
          }
        ]
      }
    ],
    beforeEnter: async (to, from, next) => {
      await router.app.$store.dispatch('project/getProjectItemAndStore', to.params.projectId)
      next()
    }
  },
  {
    path: '/pictures',
    name: 'PictureIndex',
    meta: {
      title: '照片模組',
      firstChildren: true
    },
    component: () => import('@/views/Tablet/PictureModuleIndex'),
    redirect: to => {
      return {name: 'AllPictures'}
    },
    children: [
      {
        path: 'all',
        name: 'AllPictures',
        meta: {
          title: '照片集'
        },
        component: () => import('@/views/Tablet/Pictures')
      },
      {
        path: 'map-search',
        name: 'MapSearch',
        meta: {
          title: '地圖照片'
        },
        component: () => import('@/views/Tablet/MapSearch')
      }
    ],
    beforeEnter: (to, from, next) => {
      router.app.$store.commit('project/setCurrent', {})
      next()
    }
  }

]



// WEBPACK FOOTER //
// ./src/router/tabletRoutes.js